module.exports = __webpack_public_path__ + "img/24_29.f8ff0273.png";